import { render, staticRenderFns } from "./PromotionTabs.vue?vue&type=template&id=948f3f84&scoped=true"
import script from "./PromotionTabs.vue?vue&type=script&lang=js"
export * from "./PromotionTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f3f84",
  null
  
)

export default component.exports